import zIndex from '@/modules/constants/zIndex';
import {
  Text,
  Image,
  Breakpoints,
  styled,
} from '@volkswagen-onehub/components-core';

interface DescriptionProps {
  isVideo?: boolean;
}

interface StyledDesktopImageProps {
  showMobileImage: boolean;
}

export const ImageWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background: black;
  transition: transform 0.3s ease;
`;

export const CardWrapper = styled.div(
  ({ theme }) => `
  position: relative;
  padding: ${theme.size.static400};
  display: flex;
  flex-direction: column;
  justify-content: end;
  border-radius: ${theme.size.static400};
  overflow: hidden;
  width: auto;
  color: ${theme.colors.content.inverted};
  min-height: 490px;
  cursor: pointer;
  text-decoration: none;
  
  &:hover {
    color: white;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    padding: ${theme.size.static350};

    &:hover ${ImageWrapper} {
      transform: translate(-50%, -50%) scale(1.05);
    }
  }

  @media (min-width: ${Breakpoints.b960}px) {
    min-height: auto;
    aspect-ratio: 15/10;
  }
`
);

export const LinearGradient = styled.div`
  background: linear-gradient(
    180deg,
    rgba(0, 14, 36, 0) 0%,
    rgba(0, 12, 33, 0.8) 87.57%
  );
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${zIndex.DEFAULT};
`;

export const PlayIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media (min-width: ${Breakpoints.b960}px) {
    width: 60px;

    img {
      width: 100%;
    }
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  z-index: ${zIndex.FOREGROUND};
`;

export const Description = styled(Text)<DescriptionProps>`
  ${(props) =>
    props.isVideo &&
    `
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;

      @media (min-width: ${Breakpoints.b560}px) {
        -webkit-line-clamp: 2;
      }
  `}
`;

export const StyledDesktopImage = styled(Image)<StyledDesktopImageProps>`
  height: 100%;

  ${(props) =>
    props.showMobileImage &&
    `
      display: none;
      @media (min-width: ${Breakpoints.b560}px) {
        display: block;
      }
  `}
`;

export const StyledMobileImage = styled(Image)`
  height: 100%;

  @media (min-width: ${Breakpoints.b560}px) {
    display: none;
  }
`;

export const StyledCTA = styled(Text)`
  border-bottom: 1px solid;
  display: inline-block;
  margin-top: ${(props) => props.theme.size.static100};
`;
